import Vue from 'vue'

export const _SET_MESSAGE = (details) => {
  Vue.notify({
    group: 'messages',
    type: details.type,
    text: details.message
  })
}
